import {useState} from 'react';
import get from 'lodash/get';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Divider from '@mui/material/Divider';
import Alert from '@mui/material/Alert';
import EditIcon from '@mui/icons-material/Edit';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

import CustomTextField from '../common/CustomTextField';

const NoteFormDialog = props => {
  const {isOpen, onClose, note, onSubmit} = props;
  const [comment, setComment] = useState(props.note) || '';
  return (
    <Box>
      <Dialog
       open={isOpen}
       onClose={onClose}
       fullWidth={true}
       maxWidth='sm'
       aria-labelledby="alert-dialog-title"
       aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Typography variant='h2' padding={1}>
            Edit Note
          </Typography>
          <Divider/>
          <Stack spacing={1} padding={1}>
            <CustomTextField
              type='textarea'
              multiline
              label='Note'
              placeholder='Add note here'
              defaultValue={props?.note}
              rows={3}
              onChange={e => setComment(e.target.value)}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Close</Button>
          <Button onClick={async (e) => {
            await onSubmit({...e, target: {value: comment}}, comment);
            onClose();
          }}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

const NoteEditor = props => {
  const [isOpen, setIsOpen] = useState(false);
  const preventParentEvent = (event) => {
    event.stopPropagation();
  };
  return (
    <Stack
          direction='row'
          alignItems='center'
          onClick={preventParentEvent}
      >
        <NoteFormDialog 
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          note={props.note}
          onSubmit={props.onSubmit}
        />
        <Tooltip title='Edit Memo' onClick={preventParentEvent}>
          <IconButton color='primary' onClick={e => {
            preventParentEvent(e);
            setIsOpen('comment');
          }}>
            <EditIcon 
              style={{fontSize: '0.9rem'}} 
              fill={'var(--primary)'}
              onClick={e => {
                preventParentEvent(e);
                setIsOpen('comment');
              }}
            />
          </IconButton>
        </Tooltip>
        <Typography 
          variant='small500' 
          style={{
            textOverflow: 'ellipsis', 
            overflow: 'hidden', 
            whiteSpace: 'nowrap',
            maxWidth: '500px',
            minWidth: '150px'
          }}
        >
          {props.note || '-'}
        </Typography>
    </Stack>
  );
};

export default NoteEditor;